import * as React from "react";
import { Option } from "@nozzlegear/railway";

interface Props {
    error: string | null | Option<string>
}

/**
 * Renders an error message when not null or none.
 */
export function MaybeError(props: Props): JSX.Element {
    if (props.error === null || (props.error instanceof Option && Option.isNone(props.error))) {
        return <React.Fragment />
    }

    let message: string = props.error instanceof Option 
        ? Option.get(props.error)
        : props.error;

    return <p className="red error">{message}</p>;
}
